import { ApplicationForListingDto } from 'pages/ApplicationsListingPage/ApplicationsTable/types';

export const tableColumnsNames = [
  'id',
  'applicant',
  'coApplicant',
  'status',
  'type',
  'createdAt',
  'submittedAt',
  'brokerEmail',
] as (keyof ApplicationForListingDto)[];

export interface IApplicationsAnalystTableProps {
  searchInputValue: string;
}

export interface IApplicationDataFormatted {
  id: string | number;
  applicant?: string;
  coApplicant?: string;
  status?: string;
  type?: string;
  createdAt?: Date;
  submittedAt?: Date;
  brokerEmail?: string;
}
